import React from 'react';
import styles from './GifSection.module.css';

interface GifSectionProps {
  gifSrc: string;
  gifAlt?: string;
  /** Unique section index for accessibility */
  index?: number;
}

const GifSection: React.FC<GifSectionProps> = ({
  gifSrc,
  gifAlt,
  index = 0,
}) => {
  return (
    <section
      className={styles.gifSection}
      aria-label={`Gallery section ${index + 1}`}
    >
      <img
        src={gifSrc}
        alt={gifAlt ?? `Black Beauty feature ${index + 1}`}
      />
    </section>
  );
};

export default GifSection;
